<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: 'Traders'
    };
</script>

<style>
</style>
